import { createFileRoute, redirect } from '@tanstack/react-router';
import { AuditLogList } from '@/features/audit';
import { isAdmin } from '@/auth/roles';

export const Route = createFileRoute('/_auth/_shell/auditoria')({
  // Admin-only: non-admins are bounced to the home page before the page loads
  // (defense-in-depth — the nav item is also hidden, and the endpoint 403s).
  beforeLoad: () => {
    if (!isAdmin()) throw redirect({ to: '/inicio' });
  },
  component: AuditoriaPage,
});

function AuditoriaPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <header className="flex flex-col gap-1">
        <h1 className="text-lg font-semibold text-foreground">Auditoria</h1>
        <p className="text-sm text-muted-foreground">
          Trilha de todas as ações de operadores do backoffice (mais recentes primeiro).
        </p>
      </header>
      <AuditLogList showTarget />
    </div>
  );
}
